var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 148,
    viewBox: "0 0 169 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_220_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.973 5.13632L84.8089 101.908L62.9939 5.13632C62.5576 3.2166 60.8124 1.82043 58.8927 1.82043H10.6379C8.28183 1.82043 6.36206 3.74015 6.36206 6.09618C6.36206 6.53248 6.36205 7.05604 6.62383 7.49234L50.0794 135.328C50.6902 137.074 52.2609 138.208 54.0933 138.208H115.35C117.182 138.208 118.753 137.074 119.364 135.328L162.819 7.49234C163.605 5.31083 162.383 2.86755 160.202 2.08221C159.765 1.90769 159.329 1.82043 158.805 1.82043H111.161C109.154 1.82043 107.497 3.2166 107.06 5.13632H106.973Z",
    fill: "#191818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 5.13632L84.8089 101.908L62.9939 5.13632C62.5576 3.2166 60.8124 1.82043 58.8927 1.82043H10.6379C8.28183 1.82043 6.36206 3.74015 6.36206 6.09618C6.36206 6.53248 6.36205 7.05604 6.62383 7.49234L50.0794 135.328C50.6902 137.074 52.2609 138.208 54.0933 138.208H115.35C117.182 138.208 118.753 137.074 119.364 135.328L162.819 7.49234C163.605 5.31083 162.383 2.86755 160.202 2.08221C159.765 1.90769 159.329 1.82043 158.805 1.82043H111.161C109.154 1.82043 107.497 3.2166 107.06 5.13632H106.973Z",
    stroke: "#F57423",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_220_385",
    x: 0.861572,
    y: 0.320435,
    width: 167.699,
    height: 147.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_385"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_220_385",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.74f17972cfe8eafe05f1516a2971dca3.svg";
export { ForwardRef as ReactComponent };